import { DEFAULT_MEDIA_QUERY_PLATFORMS, DEFAULT_MEDIA_QUERY_SIZES } from 'common/constants';

const { FULL_HD, DESKTOP, TABLET, MOBILE } = DEFAULT_MEDIA_QUERY_PLATFORMS;

const platformProperties = {
	[FULL_HD]: {
		minWidth: DEFAULT_MEDIA_QUERY_SIZES.fullHD.min,
		maxWidth: null,
		uiName: FULL_HD,
	},
	[DESKTOP]: {
		minWidth: DEFAULT_MEDIA_QUERY_SIZES.desktop.min,
		maxWidth: null,
		uiName: DESKTOP,
	},
	[TABLET]: {
		minWidth: DEFAULT_MEDIA_QUERY_SIZES.tablet.min,
		maxWidth: DEFAULT_MEDIA_QUERY_SIZES.desktop.min - 1,
		uiName: TABLET,
	},
	[MOBILE]: {
		minWidth: DEFAULT_MEDIA_QUERY_SIZES.mobile.min,
		maxWidth: DEFAULT_MEDIA_QUERY_SIZES.tablet.min - 1,
		uiName: MOBILE,
	},
};

export const platformsConfig = {
	[FULL_HD]: {
		[FULL_HD]: {
			...platformProperties[FULL_HD],
			minWidth: null,
			maxWidth: null,
		},
		[DESKTOP]: {
			...platformProperties[DESKTOP],
			minWidth: null,
			maxWidth: platformProperties[FULL_HD].minWidth - 1,
		},
		[TABLET]: {
			...platformProperties[TABLET],
			minWidth: null,
			maxWidth: platformProperties[TABLET].maxWidth,
		},
		[MOBILE]: platformProperties[MOBILE],
	},
	[DESKTOP]: {
		[FULL_HD]: platformProperties[FULL_HD],
		[DESKTOP]: {
			...platformProperties[DESKTOP],
			minWidth: null,
			maxWidth: null,
		},
		[TABLET]: {
			...platformProperties[TABLET],
			minWidth: null,
			maxWidth: platformProperties[TABLET].maxWidth,
		},
		[MOBILE]: {
			...platformProperties[MOBILE],
			minWidth: platformProperties[MOBILE].minWidth,
			maxWidth: platformProperties[MOBILE].maxWidth,
		},
	},
	[TABLET]: {
		[FULL_HD]: platformProperties[FULL_HD],
		[DESKTOP]: {
			...platformProperties[DESKTOP],
			minWidth: platformProperties[DESKTOP].minWidth,
			maxWidth: null,
		},
		[TABLET]: {
			...platformProperties[TABLET],
			minWidth: null,
			maxWidth: null,
		},
		[MOBILE]: {
			...platformProperties[MOBILE],
			minWidth: platformProperties[MOBILE].minWidth,
			maxWidth: platformProperties[MOBILE].maxWidth,
		},
	},
	[MOBILE]: {
		[FULL_HD]: platformProperties[FULL_HD],
		[DESKTOP]: {
			...platformProperties[DESKTOP],
			minWidth: platformProperties[DESKTOP].minWidth,
			maxWidth: null,
		},
		[TABLET]: {
			...platformProperties[TABLET],
			minWidth: platformProperties[TABLET].minWidth,
			maxWidth: null,
		},
		[MOBILE]: {
			...platformProperties[MOBILE],
			minWidth: null,
			maxWidth: null,
		},
	},
};
